// extracted by mini-css-extract-plugin
var _1 = "TextareaInlineActions-moduleicon__VoMT6 IconNG-moduleiconContainer__SxWZ0";
var _2 = "TextareaInlineActions-moduletextareaInlineActions__FMWKV";
export { _1 as "icon", _2 as "textareaInlineActions" }
